import { XMLSerializer, DOMParser } from 'xmldom';
import interactionParserUtils from './InteractionParserUtils';
import xmlDomUtils from '../../../utils/XmlDomUtils';

const xmlSerializer = new XMLSerializer();

const matchParser = {
    parse(interactionNode, language, defaultLanguage, assessmentRunId) {
        const attributes = xmlDomUtils.getAttributes(interactionNode);
        const shuffle = attributes.shuffle === 'true';
        const randomise = attributes.randomise;
        const maxAssociations = attributes.maxAssociations;
        const matchSets = interactionParserUtils.parseListOfChildren(interactionNode, 'simpleMatchSet', language, defaultLanguage);
        const objects = interactionParserUtils.parseListOfChildren(interactionNode, 'object', language, defaultLanguage);
        const prompt = interactionParserUtils.getPrompt(interactionNode, language, defaultLanguage);

        const alternatives = matchSets.map((matchSet) => {
            const domParser = new DOMParser();
            const choicesDoc = domParser.parseFromString(matchSet.content, 'text/xml');
            const choices = choicesDoc.getElementsByTagName('simpleAssociableChoice');

            // interactionParserUtils.parseListOfChildren(choicesDoc, 'simpleAssociableChoice', language, defaultLanguage);

            return Array.from(choices).map((choice) => {
                const choiceAttributes = xmlDomUtils.getAttributes(choice);
                let choiceContent = interactionParserUtils.getNodeContentAsString(choice, language, defaultLanguage);
                const choiceContentWrapped = xmlDomUtils.wrapHtmlStringIfNeeded(choiceContent);
                if (choiceContentWrapped && xmlDomUtils.isDomParsableString(choiceContentWrapped)) {
                    // Parse the content only if it contains html
                    const choiceDoc = domParser.parseFromString(choiceContentWrapped, 'text/xml');
                    const objectElements = choiceDoc.getElementsByTagName('object');

                    Array.from(objectElements).forEach((objElm) => {
                        interactionParserUtils.replaceObjectWithImg(objElm, assessmentRunId);
                    });

                    choiceContent = xmlSerializer.serializeToString(choiceDoc);
                }

                return Object.assign({}, choiceAttributes, { content: choiceContent });
            });
        });

        for (const object of objects) {
            object.data = interactionParserUtils.getMediaFileUrl(object, assessmentRunId);
        }

        return {
            alternatives,
            maxAssociations,
            objects,
            prompt,
            shuffle,
            randomise,
        };
    },
};

export default matchParser;
